<div>
  <div *ngIf="hasError" class="error" [style.min-height.px]="widgetHeight">
    <avn-empty-data-message icon="alert:warning" [text]="'dashboardScope.dashboard.error.fail-to-load-data' | transloco" [subText]="data"> </avn-empty-data-message>
  </div>

  <ng-container *ngIf="!hasError">
    <avn-timeseries
      [lineWidth]="10"
      [areaFillOpacity]="0.1"
      [style.width.%]="100"
      [style.height.%]="100"
      [style.min-height.px]="widgetHeight"
      [style.max-height.px]="widgetHeight + 100"
      [timezone]="timezone"
    >
      <!--  the trackBy function is required for sliding properly. if not there, series components gets recreated and the sliding animation does not work-->
      <ng-container *ngFor="let serie of data; trackBy: trackByFn">
        <avn-line-series
          [type]="serie.type"
          [name]="serie.name"
          [data]="serie.data"
          [color]="serie.color"
          [lineWidth]="serie.lineWidth"
          [areaFillOpacity]="serie.areaFillOpacity"
          [maxDataItems]="serie.maxDataItems"
        >
        </avn-line-series>
      </ng-container>

      <avn-simple-y-axis [title]="{ text: yAxisLabel }" [min]="0" [max]="yAxisMax" [softMax]="yAxisSoftMax" [tickInterval]="yAxisTickInterval"> </avn-simple-y-axis>

      <avn-timeseries-legend [layout]="'vertical'" [verticalAlign]="'middle'" [align]="'right'" [precision]="precision" [uom]="dataUnit" [averageLabel]="averageLabel"> </avn-timeseries-legend>

      <avn-timeseries-chart-tooltip-formatter [precision]="precision" [uom]="' ' + dataUnit"> </avn-timeseries-chart-tooltip-formatter>
    </avn-timeseries>
  </ng-container>
</div>
